// FILE: utils/formatDiamond.ts
export function formatDiamond(n: number, compact = false): string {
  if (!compact) return n.toLocaleString();
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "m";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
  return String(n);
}